import { Shark, View } from "shark-mvc";
import moment from "moment";

// import OrganizationMembership from "../../models/OrganizationMembership";
import WorkSession from "../../models/WorkSession";

import templateContent from "./home.html";
import "./style.css";

import activeWorkSessionDisplayComponent from "../../components/activeWorkSessionDisplay/activeWorkSessionDisplayComponent";
import clientManager from "../../managers/clientManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import messageModalComponent from "../../components/messageModal/messageModalComponent";
import notificationManager from "../../managers/notificationManager";
import permissionBoxComponent from "../../components/permissionBox/permissionBoxComponent";
import projectDetailPanelComponent from "../../components/projectDetailPanel/projectDetailPanelComponent";
import projectListComponent from "../../components/projectList/projectListComponent";
import taskDetailPanelComponent from "../../components/taskDetailPanel/taskDetailPanelComponent";
import taskManager from "../../managers/taskManager";
import workSessionDetailsModalComponent from "../../components/workSessionDetailsModal/workSessionDetailsModalComponent";
import workSessionManager from "../../managers/workSessionManager";
// import organizationView from "../organization/organizationView";

class HomeView extends View {
	#runningWorkSessionSyncNeeded = false;

	constructor () {
		super("homeView");

		this.setTemplate(templateContent);
		this.$mainRoute = "home";
	}

	afterLoad () {
		// document.addEventListener("keyup", this.keyupHandler);
		this.#runningWorkSessionSyncNeeded = this.selectRunningWorkSessionProjectAndTask();
	}

	beforeLoad () {
		const { clientList, projectList} = Shark.get();

		//Alice non sicura sia il posto giusto
		if (!clientList || clientList.length === 0) {
			clientManager.getList();
		}
		
		if (!projectList || projectList.length === 0) {
			projectListComponent.refreshProjectList();
		}
		else {
			// Tutto questo else serve perché se "parto" dalle stats, e ho aperto il modal di una WS, quando arrivo di qua ho già una lista dei projects, ma non è quella corretta
			// questa roba va risistemata con una projectList apposita per le stats.
			// Tra l'altro qui c'è ancora "ActiveItems" che fa schifo...
			const { activeItems, projectFilters } = Shark.get();
			projectListComponent.filterProjectList(projectFilters.searchKey);
			projectListComponent.sortProjectList(activeItems.projectSortField);
			projectListComponent.matchProjectAndOrganization();

			Shark.set({
				__projectListLocalWaitboxCSSClasses: "d-none",
			});
		}

		let { currWorkSession } = Shark.get();

		if (!currWorkSession) {
			currWorkSession = new WorkSession({
				userGuid: Shark.$store.currUser.guid,
			});
			
			Shark.set({
				currWorkSession,
			});
		}
		else {
			if (currWorkSession.endedAt !== "0000-00-00 00:00:00") {
				Shark.set("currWorkSession", new WorkSession({
					clientGuid: currWorkSession.clientGuid,
					projectGuid: currWorkSession.projectGuid,
					projectName: currWorkSession.projectName,
					taskGuid: currWorkSession.taskGuid,
					taskName: currWorkSession.taskName,
					userGuid: Shark.$store.currUser.guid,
					__projectName: currWorkSession.__projectName,
					__taskName: currWorkSession.__taskName
				}));
			}
		}

		Shark.set({
			__menuTitle: "Home",
		});

		projectListComponent.matchProjectAndOrganization();
	}

	// beforeUnload () {
	// 	document.removeEventListener("keyup", this.keyupHandler);
	// }

	canCreateManualNewWorkSession () {
		const { currWorkSession } = Shark.get();
		return currWorkSession.userGuid !== "" && currWorkSession.projectGuid !== "" && currWorkSession.taskGuid !== "";
	}

	canStartNewWorkSession () {
		const { currWorkSession, runningWorkSession } = Shark.get();
		return currWorkSession.userGuid !== "" && currWorkSession.projectGuid !== "" && currWorkSession.taskGuid !== "" && runningWorkSession === null;
	}

	// Dave: Questo è replicato nelle Stats, possiamo unificare?
	checkRunningWorksessionProjectAndTask () {
		const { projectList, runningWorkSession, taskList } = Shark.get();

		if (runningWorkSession) {
			if (projectList) {
				projectList.forEach(item => item.__isRunningWorkSessionProject = item.guid === runningWorkSession.projectGuid);
			}
			if (taskList) {
				taskList.forEach(item => item.__isRunningWorkSessionTask = item.guid === runningWorkSession.taskGuid);
			}
		}
		else {
			projectList.forEach(item => item.__isRunningWorkSessionProject = false);
			taskList.forEach(item => item.__isRunningWorkSessionTask = false);
		}
	}

	// closeAllPanels () {
	// 	// projectDetailPanelComponent.close();
	// 	// taskDetailPanelComponent.close();

	// 	// Shark.set({
	// 	// 	__projectPermissionTrayVisibile: false,
	// 	// 	__taskPermissionTrayVisibile: false,
	// 	// });
	// }

	compareLastActivity (a, b, sortDirection = 1) {
		if (a.__userLastActivityAt > b.__userLastActivityAt) {
			return -1 * sortDirection;
		}
		else if (a.__userLastActivityAt < b.__userLastActivityAt) {
			return 1 * sortDirection;
		}

		return 0;
	}

	compareProjectByName (a, b, sortDirection = 1) {
		if (a.name.toLowerCase() + a.name.toLowerCase() > b.name.toLowerCase() + b.name.toLowerCase()) {
			return 1 * sortDirection;
		}
		if (a.name.toLowerCase() + a.name.toLowerCase() < b.name.toLowerCase() + b.name.toLowerCase()) {
			return -1 * sortDirection;
		}

		return 0;
	}

	compareProjectByClientName (a , b, sortDirection = 1) {
		if (a.clientName.toLowerCase() + a.name.toLowerCase() > b.clientName.toLowerCase() + b.name.toLowerCase()) {
			return 1 * sortDirection;
		}
		if (a.clientName.toLowerCase() + a.name.toLowerCase() < b.clientName.toLowerCase() + b.name.toLowerCase()) {
			return -1 * sortDirection;
		}

		return 0;
	}

	compareTaskByName (a, b, sortDirection = 1) {
		if (a.name.toLowerCase() > b.name.toLowerCase()) {
			return 1 * sortDirection;
		}
		else if (a.name.toLowerCase() < b.name.toLowerCase()) {
			return -1 * sortDirection;
		}

		return 0;
	}

	// filterProjectList (searchKey) {
	// 	const { projectList } = Shark.get();
	// 	let visibleItemCount = 0;

	// 	projectList.forEach(item => {
	// 		if (searchKey === "" || item.clientName.toLowerCase().includes(searchKey) || item.description.toLowerCase().includes(searchKey) || item.name.toLowerCase().includes(searchKey)) {
	// 			// item.__cssClasses.add("render");
	// 			item.__renderer.addClasses("render");
	// 			visibleItemCount++;
	// 		}
	// 		else {
	// 			// item.__cssClasses.delete("render");
	// 			item.__renderer.removeClasses("render");
	// 		}
	// 		// item.flattenCSSClasses();
	// 	});

	// 	Shark.set({
	// 		__visibleProjectCount: visibleItemCount,
	// 	});
	// }

	filterTaskList (searchKey) {
		const { taskList } = Shark.get();
		let visibleItemCount = 0;

		taskList.forEach(function (item) {
			if (searchKey === "" || item.description.toLowerCase().includes(searchKey) || item.name.toLowerCase().includes(searchKey)) {
				item.__cssClasses.add("render");
				visibleItemCount++;
			}
			else {
				item.__cssClasses.delete("render");
			}
			item.flattenCSSClasses();
		});

		Shark.set({
			__visibleTaskCount: visibleItemCount,
		});
	}

	// keyupHandler (event) {
	// 	if (event.keyCode === 27) {
	// 		homeView.closeAllPanels();
	// 	}
	// }

	hideTaskColumnBtn_clickHandler () {
		Shark.$store.taskColumnCSSClasses = "";
	}

	init () {
		this.addComponents([activeWorkSessionDisplayComponent, projectDetailPanelComponent, projectListComponent, taskDetailPanelComponent, mainNavComponent, messageModalComponent, permissionBoxComponent, /*projectContextMenuComponent,*/ /*taskContextMenuComponent,*/ workSessionDetailsModalComponent]);
		const { activeItems } = Shark.get();

		//@DAVE: to do spostare dove ha senso 
		const notificationTypeMap = [
			{
				icon: "icon-close",
				type: "none",
				label: Shark.$store.labels.notification_none,
			},
			{
				icon: "icon-sound",
				type: "beep",
				label: Shark.$store.labels.notification_bip,
			},
			{
				icon: "icon-music",
				type: "sound",
				label: Shark.$store.labels.notification_sound,
			},
			{
				icon: "icon-voice",
				type: "voice",
				label: Shark.$store.labels.notification_voice,
			},
		];

		// const projectFilters = Shark.getInstance("__smart__", {
		// 	organizationGuidList: [],
		// 	// searchKey: "",
		// 	statusList: [],
		// 	onDataChanged: function (data) {
		// 		console.log(this, data);
		// 		localStorage.projectFilters = JSON.stringify(this.export());
		// 		projectListComponent.refreshProjectList();
		// 	},
		// });

		const taskFilters = Shark.getInstance("__smart__", {
			// searchKey: "",
			statusList: [],
			onDataChanged: function (data) {
				// console.log(this, data);
				localStorage.taskFilters = JSON.stringify(this.export());
				homeView.refreshTaskList();
			},
		});

		// if (localStorage.projectFilters) {
		// 	// Dave: disastro: quando parso devo verificare che nella lista salvata non ci siano cose che non ho nella lista relativa (es: una organizazzione o un progetto che non posso più vedere)
		// 	projectFilters.import(JSON.parse(localStorage.projectFilters));
		// }
		if (localStorage.taskFilters) {
			// Dave: disastro: quando parso devo verificare che nella lista salvata non ci siano cose che non ho nella lista relativa (es: una organizazzione o un progetto che non posso più vedere)
			taskFilters.import(JSON.parse(localStorage.taskFilters));
		}
		
		// activeItems.on("projectSearchKeyChanged", function () {
		// 	const searchKey = this.projectSearchKey.toLowerCase();
		// 	projectListComponent.filterProjectList(searchKey);
		// 	Shark.set({
		// 		__projectFilterActiveCSSClass: searchKey === "" ? "" : "active-filter",
		// 	});
		// });

		activeItems.on("taskSearchKeyChanged", function () {
			const searchKey = this.taskSearchKey.toLowerCase();
			homeView.filterTaskList(searchKey);
			Shark.set({
				__taskFilterActiveCSSClass: searchKey === "" ? "" : "active-filter",
			});
		});

		activeItems.on("projectSortFieldChanged", function () {
			projectListComponent.sortProjectList(this.projectSortField);
		});

		activeItems.on("taskSortFieldChanged", function () {
			homeView.sortTaskList(this.taskSortField);
		});

		// activeItems.on("showClosedProjectChanged", function () {
		// 	projectListComponent.refreshProjectList();
		// });

		// activeItems.on("showClosedTasksChanged", function () {
		// 	homeView.refreshTaskList();
		// });

		Shark.set({
			// projectFilters,
			taskFilters,

			notificationTypeMap,

			newProjectClientList: Shark.$store.newProjectClientList || [],
			organizationList: Shark.$store.organizationList || [],
			otherUserList: Shark.$store.otherUserList || [],
			projectList: Shark.$store.projectList || [],

			projectSortDirection: "DIR",

			taskColumnCSSClasses: "", // Per gestire la colonna dei task che slida in mobile

			taskList: Shark.$store.taskList || [],
			userList: Shark.$store.userList || [],
			__loggedUserCanAddTask: false,
			__projectListLocalWaitboxCSSClasses: "",
			// __projectPermissionTrayVisibile: false,
			__showManualWorkSessionForm: false,
			__taskListLocalWaitboxCSSClasses: "d-none",
			// __taskPermissionTrayVisibile: false,
			__visibleProjectCount: 0,
			__visibleTaskCount: 0,
		});

		// if (!localStorage.projectFilters) {
		// 	projectFilters.set({
		// 		organizationGuidList: Shark.$store.organizationList.map(item => item.guid),
		// 		statusList: [1],
		// 	});
		// }
		if (!localStorage.taskFilters) {
			taskFilters.set({
				statusList: [1],
			});
		}
	}

	// matchProjectAndOrganization () {
	// 	const { currUser,  organizationList, organizationMembershipList, projectList } = Shark.get();

	// 	// if (organizationList && organizationMembershipList) {
	// 	// 	const writableOrganizationList = organizationList.filter(organization => {
	// 	// 		const myMembership = organizationMembershipList.find(membership => membership.userGuid === currUser.guid);

	// 	// 		return organization.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(myMembership?.role);
	// 	// 	});

	// 	// 	Shark.set({
	// 	// 		writableOrganizationList,
	// 	// 	});
	// 	// }

	// 	if (organizationList && projectList && organizationList.length > 0 && projectList.length > 0) {
	// 		const organizationMap = new Map();

	// 		organizationList.forEach(item => {
	// 			organizationMap.set(item.guid, item);
	// 		});

	// 		projectList.forEach(project => {
	// 			if (organizationMap.has(project.organizationGuid)) {
	// 				project.__organizationLabel = organizationMap.get(project.organizationGuid).name;
	// 			}
	// 		});

	// 		Shark.set({
	// 			projectList,
	// 		});
	// 	}
	// }

	// organizationFilterBtn_clickHandler (event, data) {
	// 	console.log(data);
	// }

	// refreshProjectList () {
	// 	Shark.set({
	// 		currProject: null,
	// 		taskList: [],
	// 		__loggedUserCanAddTask: false,
	// 		__projectListLocalWaitboxCSSClasses: "",
	// 	});

	// 	const { activeItems, projectFilters, runningWorkSession } = Shark.get();

	// 	activeItems.set({
	// 		newProjectName: "",
	// 		newProjectTags: "",
	// 	});

	// 	if (projectFilters.organizationGuidList.length > 0) {
	// 		projectManager.getList(projectFilters)
	// 		.then(() => {
	// 			const { projectList } = Shark.get();

	// 			if (projectList) {
	// 				if (runningWorkSession) {
	// 					const runningWorkSessionProject = projectList.find(item => item.guid === runningWorkSession.projectGuid);
	// 					if (runningWorkSessionProject) {
	// 						runningWorkSessionProject.set({
	// 							__isRunningWorkSessionProject: true,
	// 						});
	// 					}
	// 				}
	// 				projectListComponent.filterProjectList(activeItems.projectSearchKey);
	// 				projectListComponent.sortProjectList(activeItems.projectSortField);
	// 				projectListComponent.matchProjectAndOrganization();
	// 			}
	// 			Shark.set({
	// 				__projectListLocalWaitboxCSSClasses: "d-none",
	// 			});
	// 		});
	// 	}
	// 	else {
	// 		Shark.set({
	// 			projectList: [],
	// 			__projectListLocalWaitboxCSSClasses: "d-none",
	// 		});
	// 	}
	// }

	// refreshPrjsBtn_clickHandler () {
	// 	projectListComponent.refreshProjectList();
	// }

	async refreshTaskList (filters) {
		const { currProject, taskFilters } = Shark.get();

		filters = filters || {projectGuid: currProject?.guid || ""};

		Object.assign(filters, taskFilters.export());
		
		if (filters.projectGuid !== "") {
			Shark.set({
				__taskListLocalWaitboxCSSClasses: "",
			});
	
			return taskManager.getList2(filters)
			.then(() => {
				const { activeItems, runningWorkSession, taskList } = Shark.get();

				activeItems.set({
					newTaskName: "",
					taskSearchKey: "",
				});
		
				Shark.get("currWorkSession").taskGuid = "";

				if (taskList) {
					taskList.forEach(item => {
						item.__oraganizationGuid = currProject.organizationGuid;
						item.parseUserTaskPermissions();
					});
					
					if (runningWorkSession) {
						const runningWorkSessionTask = taskList.find(item => item.guid === runningWorkSession.taskGuid);
						if (runningWorkSessionTask) {
							runningWorkSessionTask.set({
								__isRunningWorkSessionTask: true,
							});
						}
					}

					this.filterTaskList(activeItems.taskSearchKey);
					this.sortTaskList(activeItems.taskSortField);
				}

				Shark.set({
					__taskListLocalWaitboxCSSClasses: "d-none",
				});
			});
		}
	}

	refreshTaskListBtn_clickHandler () {
		const { currProject } = Shark.get();

		if (currProject) {
			var filters = {projectGuid: currProject.guid};
			this.refreshTaskList(filters);
		}
	}

	// selectAllOrganizationBtn_clickHandler () {
	// 	let { projectFilters } = Shark.get();
	// 	const { organizationList } = Shark.get();

	// 	let organizationToAdd = organizationList.map(item => item.guid);
	// 	const __allOrganizationSelected = projectFilters.organizationGuidList.length < organizationToAdd.length;
	// 	if(__allOrganizationSelected) {
	// 		projectFilters.organizationGuidList = organizationToAdd;
	// 	}
	// 	else {
	// 		projectFilters.organizationGuidList = [];
	// 	}
	// 	Shark.set({
	// 		projectFilters,
	// 		__allOrganizationSelected,
	// 	});			
	// 	console.log(projectFilters.organizationGuidList);
	// 	Shark.render(); // Mi aspetteri che lo tracciasse in automatico
	// }

	// selectInverseOrganizationBtn_clickHandler () {
	// 	let { projectFilters, organizationList} = Shark.get();

	// 	organizationList.forEach(user => {
	// 		if (!projectFilters.organizationGuidList.includes(user.guid)) {
	// 			projectFilters.organizationGuidList.push(user.guid);
	// 		}
	// 		else {
	// 			projectFilters.organizationGuidList.splice(projectFilters.organizationGuidList.indexOf(user.guid), 1);
	// 		}
	// 	});	

	// 	Shark.set({
	// 		projectFilters,
	// 	});
	// }

	// selectNoneOrganizationBtn_clickHandler () {
	// 	let { projectFilters} = Shark.get();

	// 	projectFilters.organizationGuidList = [];

	// 	Shark.set({
	// 		projectFilters,
	// 	});
	// }


	async selectRunningWorkSessionProjectAndTask () {
		const { projectList } = Shark.get();

		if (projectList && projectList.length > 0) {
			const selectedProject = projectList.filter(item => item.__isRunningWorkSessionProject);

			if (selectedProject.length > 0) {
				await projectListComponent.singleProject_clickHandler(null, { guid: selectedProject[0].guid });
			}
			
			const { taskList } = Shark.get();
			
			if (taskList && taskList.length > 0) {
				const selectedTask = taskList.filter(item => item.__isRunningWorkSessionTask);
				
				if (selectedTask.length > 0) {
					this.singleTask_clickHandler(null, { guid: selectedTask[0].guid });
		
					return true;
				}
				else {
					return false;
				}
			}
			else {
				return false;
			}
		}
		else {
			return false;
		}
	}

	// async singleProject_clickHandler (event, data) {
	// 	console.log({event, data});

	// 	Shark.$store.taskList = [];
	// 	Shark.$store.taskColumnCSSClasses = "project-selected";
	// 	Shark.$store.__taskListLocalWaitboxCSSClasses = "";

	// 	const selectedProjectGuid = data.guid;
	// 	let currProject;
	// 	const { currUser, currWorkSession, organizationMembershipList, projectList, writableOrganizationList } = Shark.get();

	// 	projectList.forEach(item => {
	// 		item.__selected = item.guid === selectedProjectGuid;
			
	// 		if (item.__selected) {
	// 			// item.__cssClasses.add("active");
	// 			item.__renderer.addClasses("active");

	// 			currProject = item;
	// 			// selectedProjectGuid = currProject.guid;
	// 			currWorkSession.set({
	// 				clientGuid: currProject.clientGuid,
	// 				projectGuid: currProject.guid,
	// 				taskGuid: "",
	// 			});
	// 		}
	// 		else {
	// 			// item.__cssClasses.delete("active");
	// 			item.__renderer.removeClasses("active");

	// 		}
	// 		// item.flattenCSSClasses();
	// 	});

	// 	let loggedUserCanAddTask = false;

	// 	if (organizationMembershipList) {
	// 		const myMembership = organizationMembershipList.find(membership => currProject.organizationGuid === membership.organizationGuid && membership.userGuid === currUser.guid);
	// 		Shark.$store.currUser.__canCurrUserAddTask = [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER, OrganizationMembership.ROLE_OWNER].includes(myMembership?.role);
	// 		// loggedUserCanAddTask = writableOrganizationList.map(item => item.guid).includes(currProject.organizationGuid) || currProject.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(myMembership?.role);
	// 	}

	// 	console.log({projectList});

	// 	Shark.set({
	// 		currProject,
	// 		currUser,
	// 		projectList,
	// 		__canCreateManualWorkSession: this.canCreateManualNewWorkSession(),
	// 		__canStartWorkSession: this.canStartNewWorkSession(),
	// 		// __loggedUserCanAddTask: loggedUserCanAddTask,
	// 		__taskListLocalWaitboxCSSClasses: "",
	// 	});

	// 	const filters = { projectGuid: selectedProjectGuid };

	// 	if (window.outerWidth > 576) {
	// 		await this.refreshTaskList(filters);
	// 	}
	// 	else {
	// 		await setTimeout(async () => {
	// 			await this.refreshTaskList(filters);
	// 		}, 250);
	// 	}
	// }

	singleTask_clickHandler (event, data) {
		// console.log({event, data});

		const { currWorkSession, taskList } = Shark.get();
		let currTask;

		taskList.forEach(item => {
			item.__selected = item.guid === data.guid.toString();
			item.selected = item.guid === data.guid.toString();

			if (item.__selected) {
				item.__cssClasses.add("active");
				currTask = item;
				currWorkSession.set("taskGuid", item.guid);
			}
			else {
				item.__cssClasses.delete("active");
			}
			item.flattenCSSClasses();
		});

		// console.log({taskList, currWorkSession});

		Shark.set({
			currTask,
			taskList,
			__canCreateManualWorkSession: this.canCreateManualNewWorkSession(),
			__canStartWorkSession: this.canStartNewWorkSession(),
		});
	}

	// sortProjectList (sortField) {
	// 	const { activeItems, newlyAddedProject, projectList, projectSortDirection } = Shark.get();
	// 	const newProjectSortDirection = activeItems.projectSortField === sortField ? (projectSortDirection === "DIR" ? "INV" : "DIR") : "DIR";
	// 	const sortMultiplier = 1;//newProjectSortDirection === "INV" ? -1 : 1;

	// 	console.log({ projectSortField: activeItems.projectSortField, sortField, newProjectSortDirection, projectSortDirection});
		
	// 	if (sortField === "name") {
	// 		projectList.sort((a, b) => {
	// 			if (a.guid === newlyAddedProject?.guid) {
	// 				return -1;
	// 			}
	// 			else if (b.guid === newlyAddedProject?.guid) {
	// 				return 1;
	// 			}

	// 			return this.compareProjectByName(a, b, sortMultiplier);
	// 		});
	// 	}
	// 	else if (sortField === "client"){
	// 		projectList.sort((a, b) => {
	// 			if (a.guid === newlyAddedProject?.guid) {
	// 				return -1;
	// 			}
	// 			else if (b.guid === newlyAddedProject?.guid) {
	// 				return 1;
	// 			}

	// 			return this.compareProjectByClientName(a, b, sortMultiplier) || this.compareProjectByName(a, b, sortMultiplier);
	// 		});
	// 	}
	// 	else {
	// 		projectList.sort((a, b) => {
	// 			if (a.guid === newlyAddedProject?.guid) {
	// 				return -1;
	// 			}
	// 			else if (b.guid === newlyAddedProject?.guid) {
	// 				return 1;
	// 			}

	// 			return this.compareLastActivity(a, b, sortMultiplier) || this.compareProjectByName(a, b, sortMultiplier);
	// 		});
	// 	}

	// 	Shark.set({
	// 		newlyAddedProject: null,
	// 		projectList,
	// 		projectSortDirection: newProjectSortDirection,
	// 	});
	// }

	sortTaskList (sortField) {
		const { newlyAddedTask, taskList } = Shark.get();

		if (taskList) {
			if (sortField === "name") {
				taskList.sort((a, b) => {
					if (a.guid === newlyAddedTask?.guid) {
						return -1;
					}
					else if (b.guid === newlyAddedTask?.guid) {
						return 1;
					}

					return this.compareTaskByName(a, b);
				});
			}
			else {
				taskList.sort((a, b) => {
					if (a.guid === newlyAddedTask?.guid) {
						return -1;
					}
					else if (b.guid === newlyAddedTask?.guid) {
						return 1;
					}

					return this.compareLastActivity(a, b) || this.compareTaskByName(a, b);
				});
			}
		}

		Shark.set({
			newlyAddedTask: null,
			taskList,
		});
	}

	startSessionBtn_clickHandler () {
		let workSession = Shark.get("currWorkSession");
		let errorFields = "";

		if (!workSession.userGuid || workSession.userGuid === "") {
			errorFields += "user, ";
		}

		if (!workSession.projectGuid || workSession.projectGuid === "") {
			errorFields += "projects, ";
		}

		if (!workSession.taskGuid || workSession.taskGuid === "") {
			errorFields += "activities, ";
		}

		if (errorFields === "") {
			var now = moment();
			workSession.startDate = now;
			
			workSessionManager.start(workSession)
			.then(() => {
				document.title = "TimeCorder - Sessione in corso";
				Shark.set({
					currWorkSession: new WorkSession({
						clientGuid: workSession.clientGuid,
						projectGuid: workSession.projectGuid,
						projectName: workSession.projectName,
						taskGuid: workSession.taskGuid,
						taskName: workSession.taskName,
						userGuid: Shark.$store.currUser.guid,
					}),
					runningWorkSession: workSession,
				});

				const { activeItems, currProject, currTask } = Shark.get();
				currProject.set({
					userLastActivityAt: now.format("YYYY-MM-DD HH:mm:ss"),
					userLastActivityAtGuid: Shark.$store.currUser.guid,
				});
				currTask.set({
					userLastActivityAt: now.format("YYYY-MM-DD HH:mm:ss"),
					userLastActivityAtGuid: Shark.$store.currUser.guid,
				});

				Shark.set({
					currProject,
					currTask,
				});
		
				this.checkRunningWorksessionProjectAndTask();
				projectListComponent.sortProjectList(activeItems.projectSortField);
				this.sortTaskList(activeItems.taskSortField);
				notificationManager.stopNotWorkingTimeNotifications();
			});
		}
		else {
			messageModalComponent.open("Attention, make a choice in : " + errorFields.substr(0, errorFields.length - 2));
		}
	}

	workSessionManager_openWSCheckedHandler () {
		homeView.checkRunningWorksessionProjectAndTask();

		if (homeView.#runningWorkSessionSyncNeeded) {
			homeView.#runningWorkSessionSyncNeeded = false;
			homeView.selectRunningWorkSessionProjectAndTask();
		}
	}
}

const homeView = new HomeView();

Shark.registerView(homeView);

export default homeView;
